/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PingRequestApiModel } from '../../models/ping-request-api-model';
import { PingResponseApiModel } from '../../models/ping-response-api-model';

export interface CreatePing$Params {

/**
 * Pass your token via the `Authorization` header prefixed with `Bearer` (e.g. `Authorization: Bearer xxxxxxx`)
 */
  Authorization?: string;
  
    /**
     * Zipcode, state and date of birth are the minimum required fields for a valid Ping request.
     *
     * On a successful Ping, a `campaignId` and `leadId` will be returned. These values should then be used to Post the lead if the bid is won.
     */
    body: PingRequestApiModel
}

export function createPing(http: HttpClient, rootUrl: string, params: CreatePing$Params, context?: HttpContext): Observable<StrictHttpResponse<PingResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, createPing.PATH, 'post');
  if (params) {
    rb.header('Authorization', params.Authorization, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PingResponseApiModel>;
    })
  );
}

createPing.PATH = '/ping-post/ping';
